export default class VNBDto {

  constructor(json) {
    if (json) {
      this.json = json
      this.id = json.id;
      this.extId = json.extId;
      this.name = json.name;
      this.email = json.email;
      this.telefon = json.telefon;
      this.strasse = json.strasse;
      this.zusatz = json.zusatz;
      this.plz = json.plz;
      this.ort = json.ort;
      this.kanton = json.kanton;
      this.ostralPersonName = json.ostralPersonName;
      this.ostralPersonVorname = json.ostralPersonVorname;
      this.ostralPersonEmail = json.ostralPersonEmail;
      this.ostralPersonTelefon = json.ostralPersonTelefon;
    } else {
      this.json = {}
    }
  }

  get adresse() {
    return [
      [this.plz, this.ort].filter(v => v).join(' '),
      [this.strasse, this.zusatz].filter(v => v).join(' ')
    ].filter(v => v).join(', ')
  }

  get ostralVerantwortlicher() {
    return [
      this.ostralPersonName,
      this.ostralPersonVorname,
    ].filter(v => v).join(' ')
  }
}
